import { createStore } from "vuex";

export default createStore({
  state: {
    connected: false,
  },
  mutations: {
    setConnected(state, payload) {
      state.connected = payload;
    },
  },
  actions: {
    async setConnected(state) {
      const connected = true;
      console.log("gown");
      state.commit("setConnected", connected);
    },
  },
  modules: {},
  getters: {
    getConnected: (state) => state.connected,
  },
});
